/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/* eslint-disable react/no-danger */
/* eslint-disable no-await-in-loop */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/named */
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import {
  ComponentProps,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { Row, Col } from "@duxton-web/ui"
import { MENU_DETAIL } from "constants/routes"
import { fullPathWithSearchParams } from "common/utils/uri"
import notification from "components/common/notification"
import { isEmpty, get, isUndefined, debounce, camelCase } from "lodash"
import { useDispatch, useSelector } from "react-redux"
import {
  ModifierGroup,
  Modifier,
  Item,
  BCRSInfo,
  DisabledEditModifierGroup,
  TranslationDetail,
  MenuTranslationRequestData,
} from "types/models/menu"
import { SortDrawer } from "components/drawers/SortDrawer"
import { AppState } from "store/store.type"
import { actionCreator } from "store/store"
import { storageHelper } from "utils/storage"
import { minorUnitToCurrency } from "utils/currency"
import { useTranslationsMap } from "common/utils/i18n"
import { TroyWebTracker, getResponseErrorEventLabels } from "utils/tracking"
import {
  EventAction,
  EventActionEng,
  EventCategory,
  EventCategoryEng,
} from "constants/tracking"
import {
  useMenuV3ModifierGroupsInfinite,
  flattenInfiniteModifierGroups,
  useGetItemDetailsByItemIDsInfiniteQuery,
  useMenuV3ItemsInfinite,
  flattenInfiniteItemsByIDs,
  flattenInfiniteItems,
  useLazySearchItemsQuery,
  useLazySearchMenusForMexQuery,
  partialMenuApi,
  PARTIAL_MENU_REFRESH_TAGS,
  useGetTranslationMutation,
} from "queries"
import { useLinkItemToModifierGroupMutation } from "queries/modifierGroupApi"
import useRtkQueryMigrationEndpointsFlag from "hooks/useRtkQueryMigrationEndpointsFlag"
import {
  isNumeric,
  capitalizeFirstLetter,
  debounceSortHandler,
  sleep,
} from "utils/misc"
import DOMPurify from "dompurify"
import {
  REQUIRED_TO_SELECT,
  availabilityStatus,
  OPTIONAL_TO_SELECT,
  exactly,
  inBetween,
  localAction as localActionConstants,
  EventSource,
  errorTarget,
  generateRandomId,
} from "utils/modifier_group_helper"
import { AnyAction } from "redux"
import { AxiosAction, FetchMenuResponse } from "types/api"
import useInventoryContext from "hooks/useInventoryContext"
import useMenuContext from "hooks/useMenuContext"
import { useEnablePartialMenu } from "hooks/useEnablePartialMenu"
import { useMenuItemSearch } from "hooks/useMenuItemSearch"
import { isMenuSupportedLanguages } from "utils/menu_helper"
import { generateTranslationParam } from "utils/translation_helper"
import { emptyModifierGroup, initialModifiers } from "constants/menu"
import { actions } from "store/duck/menu"
import { fetchGetTranslation } from "utils/rtk_migration_helper"
import { DEFAULT_DEBOUNCE_WAIT_TIME } from "constants/ui"
import { mapItemsV2ToItems } from "utils/menuV3Mapper"
import { useMenuEditorStatus } from "../hooks/useMenuEditorStatus"
import { ModifierGroupsHeader } from "./ModifierGroupsHeader"
import {
  BCRSMap,
  ModifierGroupsDrawerForm,
  TranslationParams,
} from "./ModifierGroupsDrawer"
import LinkedItemsDrawer from "./LinkedItemsDrawer"
import ModifierGroupList from "./ModifierGroupList"
import ModifierList from "./ModifierList"
import SelectionAction from "./SelectionAction"
import ModifierGroupPreviewDrawer from "./ModifierGroupPreviewDrawer"
import { SortOrderModifierRow } from "./SortOrderModifierRow"
import { EmptyModifierGroups } from "./EmptyModifierGroups"
import { modifierGroupContainer } from "./ModifierGroups.styles"

type ModifierGroupsDrawerProps = ComponentProps<typeof ModifierGroupsDrawerForm>

const emptyItem: Item = {
  itemID: "",
  itemName: "",
  availableStatus: 0,
  priceDisplay: "",
}

const SELECT_MULTIPLE = "SELECT_MULTIPLE"
const REARRANGE = "REARRANGE"
const BOTTOMNAV = "BOTTOMNAV"

const mergeBCRSInfo = (
  current: BCRSInfo | undefined,
  formValue: BCRSMap[string] | undefined,
): BCRSInfo | undefined => {
  if (!formValue) {
    return current
  }
  return {
    ...current,
    eligible: formValue.eligible,
    unitCount: formValue.eligible ? formValue.unitCount : undefined,
  }
}
interface ModifierGroupsProps {
  routePrefix?: string
}

export const ModifierGroups = ({ routePrefix }: ModifierGroupsProps) => {
  const textMap = useTranslationsMap({
    modifierGroupName: "menu.modifierGroup.placeholder.modifierGroupName",
    modifiers: "menu.modifierGroup.label.modifiers",
    additionalPrice: "menu.modifierGroup.label.additionalPrice",
    selectionRules: "menu.modifierGroup.label.selectionRules",
    requiredToSelect: "menu.modifierGroup.label.requiredToSelect",
    exactly: "menu.modifierGroup.exactly",
    inBetween: "menu.modifierGroup.inBetween",
    linkedItems: "menu.modifierGroup.linkedItems",
    emptyLinkedItems: "menu.modifierGroup.placeholder.emptyLinkedItems",
    linkItem: "menu.modifierGroup.button.linkItem",
    createModifierGroup: "menu.modifierGroup.button.createModifierGroup",
    preview: "menu.drawers.item.buttons.preview",
    createNewModifierGroupTitle:
      "menu.modifierGroup.title.createNewModifeirGroup",
    edit: "menu.actions.edit",
    editModifierGroup: "menu.modifierGroup.editOptionGroup",
    modifierName: "menu.modifierGroup.placeholder.modifierName",
    addNewModifier: "menu.modifierGroup.addNewModifier",
    optionalForCustomer: "menu.modifierGroup.optionalForCustomer",
    customerCanOnlyChoose: "menu.modifierGroup.customerCanOnlyChoose",
    selectInBetween: "menu.modifierGroup.selectInBetween",
    selectUpTo: "menu.modifierGroup.selectUpTo",
    exceedAvailOption: "menu.errors.number.exceedAvailOption",
    enterNumberBiggerZero: "menu.errors.number.enterNumberBiggerZero",
    enterTheWholeNumber: "menu.errors.number.enterTheWholeNumber",
    numberRangeInAscending: "menu.errors.number.numberRangeInAscending",
    saveChanges: "menu.modifierGroup.button.saveChanges",
    cannotDeleteModifierGroup:
      "menu.modifierGroup.error.cannotDeleteModifierGroup",
    deleteModifierGroup: "menu.modifierGroup.button.deleteModifierGroup",
    confirmDeleteModifierGroupTitle:
      "menu.modifierGroup.confirm.title.confirmDeleteModifierGroup",
    confirmDeleteModifierGroupBody:
      "menu.modifierGroup.confirm.body.confirmDeleteModifierGroup",
    upTo: "menu.modifierGroup.input.upTo",
    requiredField: "menu.errors.requiredField",
    notifMgCreated: "menu.modifierGroup.notif.mgCreated",
    notifMgUpdated: "menu.modifierGroup.notif.mgUpdated",
    notifMgDeleted: "menu.modifierGroup.notif.mgDeleted",
    rearrangeModifier: "menu.modifierGroup.rearrangeModifier",
    notifMgAndModifierDeleted: "menu.modifierGroup.notif.mgAndModifierDeleted",
    availability1singular: "menu.modifierGroup.notif.markedAvailable.singular",
    availability2singular:
      "menu.modifierGroup.notif.markedUnavailableTillTommorow.singular",
    availability3singular:
      "menu.modifierGroup.notif.markedUnavailableIndefinitely.singular",
    availability4singular:
      "menu.modifierGroup.notif.unavailableUntilNextRestock.singular",
    availability1plural: "menu.modifierGroup.notif.markedAvailable.plural",
    availability2plural:
      "menu.modifierGroup.notif.markedUnavailableTillTommorow.plural",
    availability3plural:
      "menu.modifierGroup.notif.markedUnavailableIndefinitely.plural",
    availability4plural:
      "menu.modifierGroup.notif.unavailableUntilNextRestock.plural",
    reachEditLimitTitleDaily:
      "menu.modifierGroup.alert.title.reachEditLimitDaily",
    reachEditLimitTitleWeekly:
      "menu.modifierGroup.alert.title.reachEditLimitWeekly",
    reachEditLimitTitleMonthly:
      "menu.modifierGroup.alert.title.reachEditLimitMonthly",
    reachEditLimitBodyDaily:
      "menu.modifierGroup.alert.body.reachEditLimitDaily",
    reachEditLimitBodyWeekly:
      "menu.modifierGroup.alert.body.reachEditLimitWeekly",
    reachEditLimitBodyMonthly:
      "menu.modifierGroup.alert.body.reachEditLimitMonthly",
    itemNameExceedLimit: "menu.errors.itemNameExceedLimit",
    linkItemLimit: "menu.errors.linkItemLimit",
    priceExceedLimit: "menu.errors.price.priceExceedLimit",
    modifierGropNotExist: "menu.errors.modifierGropNotExist",
    errorCharacterLimit: "menu.errors.characterLimit",
    bulkDeleteModifierSuccess:
      "menu.modifierGroup.alert.bulkDeleteModifierSuccess",
    modifierSorted: "menu.modifierGroup.notif.modifierSorted",
    cannotSelectModifier: "menu.modifierGroup.error.cannotSelectModifier",
    cannotLinkMoreThanXValue:
      "menu.modifierGroup.error.cannotLinkMoreThanXValue",
    modGroupDetails: "inventory.modGroupDetails",
    modGroupEdit: "inventory.modGroupEdit",
    generalError: "common.loadingError.caption",
    additionalPriceLink: "menu.drawers.item.changePriceByOrderType",
    pricePlaceholder: "menu.drawers.item.placeholders.price",
    itemPromo: "menu.errors.item.itemPromo",
    menuTranslationTitle: "menuTranslation.title",
    menuTranslationEditTranslation: "menuTranslation.editTranslation",
    menuTranslationItemLabel: "menuTranslation.itemLabel",
    menuTranslationErrorAutoTranslation: "menuTranslation.errorAutoTranslation",
    menuTranslationDetailOption: "menuTranslation.detail.option",
    menuTranslationDetailOptionGroup: "menuTranslation.detail.optionGroup",
    menuTranslationLoadingAutoTranslation:
      "menuTranslation.loadingAutoTranslation",
    errorPriceDeviation: "menu.errors.advancedPricing.priceDeviation",
  })

  const [selectedModifierGroup, setSelectedModifierGroup] = useState<
    ModifierGroup
  >(emptyModifierGroup)

  const menu = useSelector((state: AppState) => state.menu)
  const { isEditAllowed } = useMenuEditorStatus()
  const {
    isFetchingMenu,
    outletV2,
    merchantGroupID,
    merchantID,
    menuGroupDetail: { menuGroupID, languageSettings },
    menu: { modifierGroups, modifierGroupSelected, modifierSelected },
    isMartStore,
    isMartDepartmentStructure,
    isSellingTimeStructure,
    enableMenuTranslationPortal,
    autoTranslationQueue,
    originalTranslationFromDSMap,
  } = menu

  const { isServiceBasedMenuEnabled } = useMenuContext()
  const enablePartialMenu = useEnablePartialMenu()
  const { refetchSearch } = useMenuItemSearch()

  const {
    flags: {
      linkItemToModifierGroup: isRtkLinkItemToModifierGroupEnabled,
      getTranslation: isRtkGetTranslationEnabled,
    },
    isLoading: isRtkFlagLoading,
  } = useRtkQueryMigrationEndpointsFlag()

  const [linkItemToModifierGroupRtk] = useLinkItemToModifierGroupMutation()

  // Fetch modifier groups using RTK Query (only when feature flag is on)
  const {
    currentData: modifierGroupsData,
    isLoading: isLoadingModifierGroups,
    isFetching: isFetchingModifierGroups,
    fetchNextPage: fetchNextPageModifierGroups,
    hasNextPage: hasNextPageModifierGroups,
    isFetchingNextPage: isFetchingNextPageModifierGroups,
    error: modifierGroupsError,
  } = useMenuV3ModifierGroupsInfinite(
    {
      merchantID,
      merchantGroupID,
    },
    {
      skip: !merchantID || !enablePartialMenu,
    },
  )

  // RTK modifier groups for new implementation
  // Note: FoodmaxapipbModifierGroup is structurally compatible with ModifierGroup
  // except for some translation types, so we cast here
  const modifierGroupsNew = useMemo(() => {
    const groups = flattenInfiniteModifierGroups(modifierGroupsData) || []
    return (groups as unknown) as ModifierGroup[]
  }, [modifierGroupsData])

  const menuTranslationSetting = menuGroupID
    ? languageSettings
    : outletV2?.menuTranslationSetting
  const isMenuTranslation =
    (enableMenuTranslationPortal &&
      isMenuSupportedLanguages(menuTranslationSetting)) ||
    false
  const isAutoTranslationEnabled =
    isMenuTranslation && !!menuTranslationSetting?.isAutoTranslationEnabled

  const currencyValue = outletV2?.currency?.code
  const [searchFilter, setSearchFilter] = useState("")

  // Check if modifier group search is active (server-side search)
  const isModifierGroupSearchActive = enablePartialMenu && !!searchFilter

  const [
    triggerSearchMenus,
    { data: searchResults, isFetching: isSearchingModifierGroups },
  ] = useLazySearchMenusForMexQuery()

  // Search results as ModifierGroup[]
  const searchedModifierGroups = useMemo(() => {
    if (!searchResults?.modifierGroups) return []
    return (searchResults.modifierGroups as unknown) as ModifierGroup[]
  }, [searchResults])

  const filteredModifierGroups = useMemo(() => {
    // When partial menu is enabled and searching, use server-side results
    if (isModifierGroupSearchActive) {
      return searchedModifierGroups
    }

    // Use RTK Query data when feature flag is on, otherwise use Redux data
    const groupsToFilter = enablePartialMenu
      ? modifierGroupsNew
      : modifierGroups || []

    // Client-side filtering (for legacy or when not searching)
    if (!searchFilter) return groupsToFilter

    return (
      groupsToFilter?.filter(mg =>
        mg.modifierGroupName
          ?.toLowerCase()
          .includes(searchFilter?.toLowerCase()),
      ) || []
    )
  }, [
    enablePartialMenu,
    searchFilter,
    searchedModifierGroups,
    modifierGroupsNew,
    modifierGroups,
    isModifierGroupSearchActive,
  ])

  // Combined loading state: use RTK loading when enablePartialMenu is on, otherwise use Redux loading
  const isLoadingModifierGroupsData = enablePartialMenu
    ? isLoadingModifierGroups ||
      isFetchingModifierGroups ||
      isSearchingModifierGroups
    : isFetchingMenu

  const allItems = useSelector((state: AppState) => state.menu.items)

  const [modifiers, setModifiers] = useState<Modifier[]>([])

  const [checkedModifierGroups, setCheckedModifierGroups] = useState<
    ModifierGroup[]
  >([])

  const [showCheckbox, setShowCheckbox] = useState<boolean>(false)

  const [checkedModifiers, setCheckedModifiers] = useState<Modifier[]>([])

  const [
    showDeleteCheckedModifiersConfirm,
    setShowDeleteCheckedModifiersConfirm,
  ] = useState<boolean>(false)

  const [
    showChangeModifierAvailabilityConfirm,
    setShowChangeModifierAvailabilityConfirm,
  ] = useState<boolean>(false)

  const [
    showSortOrderModifiersDrawer,
    setShowSortOrderModifiersDrawer,
  ] = useState<boolean>(false)

  const [
    modifierSelectedAvailability,
    setModifierSelectedAvailability,
  ] = useState<number>(availabilityStatus.available)

  const [requiredType, setRequiredType] = useState<string>(exactly)

  const [selectionRule, setselectionRule] = useState<Number>(1)

  const [linkedItems, setLinkedItems] = useState<Item[]>([])

  const [linkedItemsDrawerVisble, setLinkeItemsDrawerVisible] = useState(false)

  const [items, setItems] = useState<Item[]>([])

  const [searchValue, setSearchValue] = useState<string>("")
  const [drawerVisible, setDrawerVisible] = useState(false)

  const [modifierGroupForDrawer, setModifierGroupForDrawer] = useState<
    ModifierGroup
  >(emptyModifierGroup)

  const {
    currentData: linkedItemsByIDsData,
    isLoading: isLoadingLinkedItemsInfinite,
    fetchNextPage,
    hasNextPage: hasNextPageLinkedItems,
    isFetchingNextPage,
    error: linkedItemsError,
  } = useGetItemDetailsByItemIDsInfiniteQuery(
    {
      merchantID,
      merchantGroupID,
      itemIDs: modifierGroupForDrawer.relatedItemIDs || [],
    },
    {
      skip:
        !enablePartialMenu ||
        !modifierGroupForDrawer.relatedItemIDs?.length ||
        !merchantID,
    },
  )

  // Flatten all loaded pages and map to Item[] format
  const linkedItemsFromAPI = useMemo(() => {
    if (!enablePartialMenu || !linkedItemsByIDsData) {
      return []
    }
    const flattenedItems = flattenInfiniteItemsByIDs(linkedItemsByIDsData)
    return mapItemsV2ToItems(flattenedItems)
  }, [enablePartialMenu, linkedItemsByIDsData])

  // Show loading when fetching items and no current data available
  const isLoadingLinkedItems =
    enablePartialMenu && isLoadingLinkedItemsInfinite && !linkedItemsByIDsData

  // Check if there are more batches to load
  const hasMoreBatches = enablePartialMenu && !!hasNextPageLinkedItems

  // Handler to load more batches (called on scroll)
  const handleLoadMoreBatches = () => {
    if (hasMoreBatches && !isFetchingNextPage) {
      fetchNextPage()
    }
  }

  // Fetch items using menuV3Items infinite query when drawer is visible and enablePartialMenu is true
  const {
    currentData: menuV3ItemsData,
    isLoading: isLoadingItems,
    fetchNextPage: fetchNextPageItems,
    hasNextPage: hasNextPageItems,
    isFetchingNextPage: isFetchingNextPageItems,
  } = useMenuV3ItemsInfinite(
    {
      merchantID,
      merchantGroupID,
      filter: {
        // sellingTimeID: "", // TODO: remove sellingTimeID after BE support this
      },
    },
    {
      skip: !enablePartialMenu || !linkedItemsDrawerVisble || !merchantID,
    },
  )

  // Flatten and map menuV3Items to Item[] format
  const menuV3ItemsList = useMemo(() => {
    if (!enablePartialMenu || !menuV3ItemsData) {
      return []
    }
    return mapItemsV2ToItems(flattenInfiniteItems(menuV3ItemsData) || [])
  }, [enablePartialMenu, menuV3ItemsData])

  // Update items when menuV3ItemsList changes and drawer is visible
  useEffect(() => {
    if (
      enablePartialMenu &&
      linkedItemsDrawerVisble &&
      !!menuV3ItemsList.length
    ) {
      setItems(menuV3ItemsList)
    }
  }, [enablePartialMenu, linkedItemsDrawerVisble, menuV3ItemsList])

  // Load more handler for menuV3Items
  const handleLoadMoreItems = () => {
    if (hasNextPageItems && !isFetchingNextPageItems) {
      fetchNextPageItems()
    }
  }

  const [
    triggerSearch,
    { data: searchData, isFetching: isSearchFetching },
  ] = useLazySearchItemsQuery()

  // Derived state: true when user has entered a search query
  // Note: searchValue is already trimmed when set, so no need to trim here
  const isSearching = !!searchValue

  // Update items when search results arrive
  useEffect(() => {
    if (enablePartialMenu && isSearching && searchData?.items) {
      setItems(mapItemsV2ToItems(searchData.items))
    }
  }, [enablePartialMenu, isSearching, searchData])

  const [modifiersForDrawer, setModifiersForDrawer] = useState<Modifier[]>(
    initialModifiers,
  )

  const [modifierGroupDrawerTitle, setModifierGroupDrawerTitle] = useState<
    string
  >("")

  const [
    modifierGroupDrawerBtnTitle,
    setModifierGroupDrawerBtnTitle,
  ] = useState<string>("")

  const [previewModifierGroup, setPreviewModifierGroup] = useState<
    ModifierGroup
  >(emptyModifierGroup)

  const [previewItem, setPreviewItem] = useState<Item>(emptyItem)

  const [
    showPreviewModifierGroupDrawer,
    setShowPreviewModifierGroupDrawer,
  ] = useState<boolean>(false)

  const [localAction, setLocalAction] = useState<string>("")

  const [firstLoad, setFirstLoad] = useState<boolean>(true)

  const [
    createNewModifierGroupClicked,
    setCreateNewModifierGroupClicked,
  ] = useState<boolean>(false)

  const [
    modifyModifierGroupErrorMsg,
    setModifyModifierGroupErrorMsg,
  ] = useState<{ key: string; message: string }>()

  const [linkedItemChange, setLinkedItemChange] = useState<boolean>(false)

  const [countCheckedModifiers, setCountCheckedModifiers] = useState<number>(0)

  const dispatch = useDispatch()
  const [getTranslationRtk] = useGetTranslationMutation()
  const limitCheckedModifiers = 50
  const history = useHistory()
  const location = useLocation()

  const { itemID: modifierParam } = useParams<{
    itemID: string
  }>()

  const trackingLabels: any = {
    ...(merchantID
      ? { STORE_ID: merchantID }
      : { MERCHANT_GROUP_ID: merchantGroupID, MENU_GROUP_ID: menuGroupID }),
    IS_PARTIAL_MENU: enablePartialMenu,
  }

  const refreshMenu = async () => {
    if (enablePartialMenu) {
      dispatch(partialMenuApi.util.invalidateTags(PARTIAL_MENU_REFRESH_TAGS))
      await refetchSearch()
      return Promise.resolve()
    }

    // Feature flag OFF: Use existing Redux approach
    if (isMartDepartmentStructure) {
      return dispatch(
        actionCreator.menu.fetchCatalogue({
          merchantID,
          merchantGroupID,
          menuGroupID,
          isSellingTimeStructure,
        }),
      )
    }

    return dispatch(
      actionCreator.menu.fetchMenu({
        merchantID,
        merchantGroupID,
        menuGroupID,
        isSellingTimeStructure,
      }),
    )
  }

  const disabledModifierGroup = (modifierGroupID: string) => {
    return storageHelper.getDisabledModifierGroup(
      modifierGroupID,
    ) as DisabledEditModifierGroup
  }

  const alertReachEditLimitBody = (modifierGroupID: string) => {
    const modGroup = filteredModifierGroups?.find(
      mg => mg.modifierGroupID === modifierGroupID,
    )
    return `${modGroup?.modifierGroupName}. ${textMap[
      `reachEditLimitBody${capitalizeFirstLetter(
        disabledModifierGroup(modifierGroupID)?.range,
      )}`
    ]
      .replace(/<x>/i, disabledModifierGroup(modifierGroupID).limit)
      .replace(/<date.short>/i, disabledModifierGroup(modifierGroupID).date)
      .replace(
        /<a>/i,
        `<a href='${storageHelper.getTroyHelpCenterUrlV2()}' target='_blank' rel='noreferrer'>`,
      )}`
  }

  const availabilityStatusTxt = (availability: number) => {
    let status = ""
    if (availability === availabilityStatus.available) {
      status = "Available"
    } else if (availability === availabilityStatus.unAvailableToday) {
      status = "Unavailable till tomorrow"
    } else {
      status = "Unavailable indefinitely"
    }
    return status
  }

  const setSelectedRequireType = (pickedModifierGroup: ModifierGroup) => {
    const { selectionRangeMax, selectionRangeMin } = pickedModifierGroup
    let modifierGroupRequiredType: string = ""
    if (selectionRangeMax === selectionRangeMin) {
      // Require exactly
      modifierGroupRequiredType = exactly
    } else if (
      selectionRangeMin > 0 &&
      selectionRangeMin !== selectionRangeMax
    ) {
      // Require inBetween
      modifierGroupRequiredType = inBetween
    }
    setRequiredType(modifierGroupRequiredType)
  }

  const handleOnCloseDrawer = () => {
    setLinkedItems([])
    setLinkedItemChange(false)
    setDrawerVisible(false)
    dispatch(actionCreator.menu.clearSelectedModifier())
    setModifiersForDrawer([
      ...initialModifiers.map(m => ({
        ...m,
        modifierName: "",
        priceInMin: 0,
      })),
    ])
    setModifierGroupForDrawer({
      ...emptyModifierGroup,
      modifierGroupName: "",
    })
    if (!isEmpty(modifierParam)) {
      history.replace(
        location.pathname.substring(0, location.pathname.lastIndexOf("/")),
      )
    }
  }

  const handleOnCloseLinkedItemsDrawer = () => {
    setLinkeItemsDrawerVisible(false)
    setSearchValue("")

    // if user uncheck item than click back or close
    // linkedItemDrawer should persist relatedItem to
    // linkedItems
    const itemsSource =
      enablePartialMenu && linkedItemsFromAPI.length
        ? linkedItemsFromAPI
        : allItems

    const tmpLinkedItems: Item[] = []
    modifierGroupForDrawer.relatedItemIDs.forEach(itemID => {
      const item = itemsSource.find(it => it.itemID === itemID)
      tmpLinkedItems.push(item || emptyItem)
    })
    setLinkedItems(tmpLinkedItems)
    setLinkedItemChange(false)
  }

  const handleOnClickCreateNewModifier = () => {
    setModifierGroupForDrawer({
      ...emptyModifierGroup,
      modifierGroupName: "",
    })
    setRequiredType(exactly)
    setModifiersForDrawer([
      ...initialModifiers.map(m => ({
        ...m,
        modifierName: "",
        priceInMin: 0,
      })),
    ])
    setModifierGroupDrawerTitle(textMap.createNewModifierGroupTitle)
    setModifierGroupDrawerBtnTitle(textMap.createModifierGroup)
    setDrawerVisible(true)
    setCreateNewModifierGroupClicked(true)
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.clickAddModifiergroup,
      labels: trackingLabels,
    })
  }

  const handleOnClickLinkItem = () => {
    setLinkeItemsDrawerVisible(true)
    // For legacy flow (enablePartialMenu = false), set items from Redux state
    if (!enablePartialMenu) {
      setItems(allItems)
    } else if (!linkedItemChange) {
      // Only reinitialize from server state when no prior confirmed selection exists.
      // If linkedItemChange is true the user already confirmed a selection via "Link",
      // so we must preserve linkedItems instead of resetting it.
      const linkedItemsTmp = (modifierGroupForDrawer.relatedItemIDs || []).map(
        itemID => {
          const loadedItem = linkedItemsFromAPI.find(it => it.itemID === itemID)
          return loadedItem || { ...emptyItem, itemID }
        },
      )
      setLinkedItems(linkedItemsTmp)
    }
  }

  const handleItemCheckboxChange = (itemID?: string) => {
    if (!itemID) return

    const itemExist = linkedItems.find((i: Item) => i.itemID === itemID)

    if (!itemExist) {
      const item = items.find(i => i.itemID === itemID)
      if (!item) return
      setLinkedItems((prevState: Item[]) => [...prevState, item])
    } else {
      setLinkedItems((prevState: Item[]) =>
        prevState.filter((i: Item) => i.itemID !== itemID),
      )
    }
  }

  const handleSubmitLinkItem = async () => {
    setLinkeItemsDrawerVisible(false)
    setLinkedItemChange(true)
  }

  const handleCloseCheckbox = () => {
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.clickExitModifierAction,
      labels: {
        ...trackingLabels,
        NUM_MODIFIER_SELECTED: checkedModifiers?.length,
        NUM_MODIFIERGROUP_SELECTED: checkedModifierGroups?.length,
        PAGELAYOUT: BOTTOMNAV,
        MODIFIER_ID: JSON.stringify(checkedModifiers?.map(m => m?.modifierID)),
      },
    })
    setShowCheckbox(false)
    setCheckedModifiers([])
    setCheckedModifierGroups([])
  }

  const handleSelectModifierGroup = (modifierGroup: ModifierGroup) => {
    setModifiers(modifierGroup.modifiers)
    setSelectedModifierGroup(modifierGroup)
    setSelectedRequireType(modifierGroup)
  }
  const { mustEditThroughMenu, isInventory } = useInventoryContext()

  const handleEditModifier = (modifierGroup: ModifierGroup) => {
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.clickEditModifiergroup,
      labels: {
        ...trackingLabels,
        MODIFIER_GROUP_ID: modifierGroup?.modifierGroupID,
      },
    })

    setModifierGroupForDrawer(modifierGroup)

    if (modifierGroup?.selectionRangeMin === modifierGroup?.selectionRangeMax) {
      setRequiredType(exactly)
    } else if (
      modifierGroup?.selectionRangeMin < modifierGroup?.selectionRangeMax
    ) {
      setRequiredType(inBetween)
    }

    setModifiersForDrawer([
      ...modifierGroup.modifiers.map(mod => ({
        ...mod,
        priceInMin: minorUnitToCurrency(mod.priceInMin, currencyValue),
      })),
    ])
    setModifierGroupDrawerTitle(
      // eslint-disable-next-line no-nested-ternary
      !mustEditThroughMenu
        ? !isInventory
          ? textMap.editModifierGroup
          : textMap.modGroupEdit
        : textMap.modGroupDetails,
    )
    setModifierGroupDrawerBtnTitle(textMap.saveChanges)

    setDrawerVisible(true)

    // When enablePartialMenu is true, allItems will be empty
    // se set empty array here and populate it with the query result via useEffect
    if (enablePartialMenu) {
      setLinkedItems([])
    } else {
      const linkedItemsTmp: Item[] = allItems.filter(({ itemID }) =>
        modifierGroup.relatedItemIDs.includes(itemID ?? ""),
      )
      setLinkedItems(linkedItemsTmp)
    }
  }

  useEffect(() => {
    if (modifierParam) {
      const urlModifier = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === modifierParam,
      )
      if (urlModifier) {
        handleSelectModifierGroup(urlModifier)
        handleEditModifier(urlModifier)
      }
    }
  }, [modifierParam, filteredModifierGroups])

  // Re-select the current modifier group when search results change (e.g., after cache invalidation)
  // This ensures the modifiers list is updated after edits
  useEffect(() => {
    if (
      isModifierGroupSearchActive &&
      selectedModifierGroup?.modifierGroupID &&
      searchedModifierGroups.length > 0
    ) {
      const updatedModifierGroup = searchedModifierGroups.find(
        mg => mg.modifierGroupID === selectedModifierGroup.modifierGroupID,
      )
      if (updatedModifierGroup) {
        setSelectedModifierGroup(updatedModifierGroup)
        setModifiers(updatedModifierGroup.modifiers || [])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchedModifierGroups, isModifierGroupSearchActive])

  // Update linkedItems when items are fetched from API (for enablePartialMenu)
  // Only include loaded items (for ModifierGroupsDrawer display)
  // Guard with linkedItemChange so paginated fetches don't overwrite user's pending selection
  useEffect(() => {
    if (
      enablePartialMenu &&
      !linkedItemChange &&
      linkedItemsFromAPI.length &&
      modifierGroupForDrawer.relatedItemIDs?.length
    ) {
      const linkedItemsTmp: Item[] = linkedItemsFromAPI.filter(({ itemID }) =>
        modifierGroupForDrawer.relatedItemIDs.includes(itemID ?? ""),
      )
      setLinkedItems(linkedItemsTmp)
    }
  }, [
    enablePartialMenu,
    linkedItemChange,
    linkedItemsFromAPI,
    modifierGroupForDrawer.relatedItemIDs,
  ])

  const handleOnClickEditModifier = (modifierGroup?: ModifierGroup) => {
    const editedModifierGroup = modifierGroup || selectedModifierGroup
    handleEditModifier(editedModifierGroup)
    const nextPath = `${MENU_DETAIL({
      isMartStore,
      merchantID: menuGroupID || merchantID,
      tabKey: "modifierGroups",
      itemID: editedModifierGroup.modifierGroupID,
      customRoutePrefix: routePrefix,
    })}`
    const destination = fullPathWithSearchParams({
      nextPath,
    })
    history.replace(destination)

    // HINT: Update the auto translation in modifierGroup
    if (isAutoTranslationEnabled) {
      const callingModifierGroupAutoTranslation = menuTranslationSetting?.translationModelSupportedLanguages?.filter(
        value => {
          return !editedModifierGroup?.nameTranslation?.translation[value]
            ? value
            : null
        },
      )
      if (
        callingModifierGroupAutoTranslation &&
        callingModifierGroupAutoTranslation.length > 0
      ) {
        const data: MenuTranslationRequestData = {
          textType: "name",
          entity: "modifierGroup",
          text: editedModifierGroup.modifierGroupName,
          textSourceLang: menuTranslationSetting?.menuDefaultLanguage || "",
          textTargetLang: callingModifierGroupAutoTranslation,
          destinationKey: editedModifierGroup.modifierGroupID,
        }
        dispatch(
          actionCreator.menu.updateExistingTranslation({
            data,
            merchantID,
            merchantGroupID,
            menuGroupID,
          }),
        )
      }
      editedModifierGroup.modifiers.map(async modifier => {
        const callingModifierAutoTranslation = menuTranslationSetting?.translationModelSupportedLanguages?.filter(
          value => {
            return !modifier.nameTranslation?.translation[value] ? value : null
          },
        )
        if (
          callingModifierAutoTranslation &&
          callingModifierAutoTranslation.length > 0
        ) {
          const data: MenuTranslationRequestData = {
            textType: "name",
            entity: "modifier",
            text: modifier.modifierName,
            textSourceLang: menuTranslationSetting?.menuDefaultLanguage || "",
            textTargetLang: callingModifierAutoTranslation,
            destinationKey: `${editedModifierGroup?.modifierGroupID},${modifier.modifierID}`,
          }
          await dispatch(
            actionCreator.menu.updateExistingTranslation({
              data,
              merchantID,
              merchantGroupID,
              menuGroupID,
            }),
          )
        }
        return null
      })
    }
  }

  const handleOnSortOrderModifierChange = (newModifiers: Modifier[]) => {
    setModifiersForDrawer([...newModifiers])
  }

  const handleOnAddEmptyModifier = () => {
    setModifiersForDrawer(prev => [
      ...prev,
      ...initialModifiers.map(modif => ({
        ...modif,
        priceInMin: 0,
        modifierName: "",
        modifierID: generateRandomId(5),
      })),
    ])
  }

  const handleOnRemoveModifier = (index: number) => {
    if (modifiersForDrawer?.length === 1) {
      return
    }
    setModifiersForDrawer(prev => {
      const prevModifier = prev
      const removedArr = prevModifier.splice(index, 1)[0]
      const updatedModifiersForDrawer = removedArr?.modifierID
        ? prevModifier.filter(item => item.modifierID !== removedArr.modifierID)
        : prevModifier
      return updatedModifiersForDrawer
    })
  }

  const handleOnChangeModifierGroupName = (val: string) => {
    setModifierGroupForDrawer(prev => ({
      ...prev,
      modifierGroupName: val,
    }))
  }

  const handleOnChangeModifierGroupRequiredType = (val: string) => {
    setRequiredType(val)
    let selectionRangeMin = modifierGroupForDrawer.selectionRangeMin
    let selectionRangeMax = modifierGroupForDrawer.selectionRangeMax

    if (val === exactly) {
      selectionRangeMax = selectionRangeMin
    } else if (val === inBetween) {
      selectionRangeMin = 1
      selectionRangeMax = 2
    }

    setModifierGroupForDrawer(prev => ({
      ...prev,
      selectionRangeMin,
      selectionRangeMax,
    }))
  }

  const handleOnChangeModifierGroupStartValue = (val: string) => {
    if (!isNumeric(val)) return

    let selectionRangeMin = Number(val)
    let selectionRangeMax = modifierGroupForDrawer.selectionRangeMax

    // this condition prevent selection rules option
    // change to optional
    if (Number(val) === 0 && selectionRule === REQUIRED_TO_SELECT) {
      selectionRangeMin = 1
    } else {
      selectionRangeMin = Number(val)
    }

    // if selectionRangeMin === selectionRangeMax
    // than set requiredType to exactly
    if (selectionRangeMin === selectionRangeMax) {
      setRequiredType(exactly)
    }

    // On single selection (exactly)
    // selectionRangeMin = selectionRangeMax
    if (requiredType === exactly) {
      selectionRangeMax = Number(val)
    }
    setModifierGroupForDrawer(prev => ({
      ...prev,
      selectionRangeMin,
      selectionRangeMax,
    }))
  }

  const handleOnChangeModifierGroupEndValue = (val: string) => {
    if (!isNumeric(val)) return

    const selectionRangeMax = Number(val)
    let selectionRangeMin = modifierGroupForDrawer.selectionRangeMin

    // if selectionRangeMin === selectionRangeMax
    // than set requiredType to exactly
    if (selectionRangeMin === selectionRangeMax) {
      setRequiredType(exactly)
    }

    // On optional, modifier selectionRangeMin should be 0
    if (selectionRule === OPTIONAL_TO_SELECT) {
      selectionRangeMin = 0
    }
    setModifierGroupForDrawer(prev => ({
      ...prev,
      selectionRangeMax,
      selectionRangeMin,
    }))
  }

  const handleOnChangeModifierGroupSelectionRuleChange = (val: number) => {
    let selectionRangeMin = modifierGroupForDrawer.selectionRangeMin
    let selectionRangeMax = modifierGroupForDrawer.selectionRangeMax
    if (val === REQUIRED_TO_SELECT) {
      selectionRangeMin = 1
      selectionRangeMax = 1
      setselectionRule(REQUIRED_TO_SELECT)
      setRequiredType(exactly)
    } else {
      selectionRangeMin = 0
      selectionRangeMax = 1
      setselectionRule(OPTIONAL_TO_SELECT)
    }
    setModifierGroupForDrawer(prev => ({
      ...prev,
      selectionRangeMax,
      selectionRangeMin,
    }))
  }

  const handleOnDeleteModifierGroup = async () => {
    dispatch(actionCreator.global.showLoading())
    const resp: any = await dispatch(
      actionCreator.modifierGroup.deleteModifierGroup(
        selectedModifierGroup.modifierGroupID,
        merchantID,
        merchantGroupID,
        menuGroupID,
      ),
    )
    let labels: any = {
      ...trackingLabels,
      MODIFIERGROUP_ID: selectedModifierGroup?.modifierGroupID,
    }
    if (resp?.type?.endsWith("_SUCCESS")) {
      labels = {
        ...labels,
        STATUS: "SUCCESS",
        REASON: "",
        ERROR_MSG: "",
      }
      handleOnCloseDrawer()
      await refreshMenu()
      setModifiers([])
      setFirstLoad(true)
      dispatch(actionCreator.global.hideLoading())
      notification.success({
        message: textMap.notifMgDeleted,
      })
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
    }

    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.submitDeleteModifiergroup,
      labels,
    })
    dispatch(actionCreator.global.hideLoading())
  }

  const handleOnChangeCheckboxModifierGroup = (index: any) => {
    // itemID exist mean uncheck
    const itemExist = checkedModifierGroups.find(
      i => i.modifierGroupID === filteredModifierGroups[index]?.modifierGroupID,
    )

    if (!itemExist) {
      if (checkedModifiers?.length > limitCheckedModifiers) {
        notification.error({
          message: textMap.cannotSelectModifier.replace(
            /<x>/i,
            `${checkedModifiers?.length}`,
          ),
        })
        return
      }
      // check
      setCheckedModifierGroups(prev => [...prev, filteredModifierGroups[index]])
      // also check all modifier under checked
      // modifier group

      setCheckedModifiers(prev => {
        const newCheckedModifiers = [
          ...prev,
          ...filteredModifierGroups[index]?.modifiers,
        ]
        // remove duplicate to handle if some of the items is already checked
        return [
          ...new Map(
            newCheckedModifiers.map(item => [item.modifierID, item]),
          ).values(),
        ]
      })
    } else {
      // uncheck
      setCheckedModifierGroups((prevState: any) => [
        ...prevState.filter(
          (i: any) =>
            i.modifierGroupID !==
            filteredModifierGroups[index]?.modifierGroupID,
        ),
      ])
      // also uncheck all modifier under unchecked
      // modifier group
      setCheckedModifiers(prev => [
        ...prev.filter(
          mod =>
            !filteredModifierGroups[index]?.modifiers
              .map(mf => mf.modifierID)
              .includes(mod.modifierID),
        ),
      ])
    }
    if (!showCheckbox) {
      setShowCheckbox(true)
    }
  }

  const handleOnToggleCheckbox = (val: boolean, eventSource: EventSource) => {
    setShowCheckbox(val)
    let labels: any
    if (val) {
      labels = {
        ...trackingLabels,
        VALUE: SELECT_MULTIPLE,
      }
      if (eventSource === EventSource.MODIFIER_GROUP) {
        labels = {
          ...labels,
          NUM_MODIFIERGROUP: filteredModifierGroups?.length,
        }
      } else if (eventSource === EventSource.MODIFIER) {
        labels = {
          ...labels,
          MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
          NUM_MODIFIER: modifiers?.length,
        }
      }
      TroyWebTracker.sendEvent({
        category: EventCategory.menuModifierGroupsTab,
        action:
          eventSource === EventSource.MODIFIER_GROUP
            ? EventAction.clickModifiergroupMore
            : EventAction.clickModifierMore,
        labels,
      })
    }
  }

  const handleOnChangeModifierCheckbox = (index: number) => {
    // itemID exist mean uncheck
    const itemExist = checkedModifiers.find(
      i => i.modifierID === modifiers[index].modifierID,
    )

    if (!itemExist) {
      if (checkedModifiers?.length > limitCheckedModifiers) {
        notification.error({
          message: textMap.cannotSelectModifier.replace(
            /<x>/i,
            `${checkedModifiers?.length}`,
          ),
        })
        return
      }
      // check
      setCheckedModifiers(prev => [...prev, modifiers[index]])
    } else {
      // uncheck
      setCheckedModifiers((prevState: Modifier[]) => [
        ...prevState.filter(
          (i: Modifier) => i.modifierID !== modifiers[index].modifierID,
        ),
      ])
    }
    if (!showCheckbox) {
      setShowCheckbox(true)
    }
  }

  const handleToggleCreateNewModifierGroupClicked = (val: boolean) => {
    setCreateNewModifierGroupClicked(val)
  }

  useEffect(() => {
    // If all modifiers are selected than also
    // select the modifier group and if all
    // modifiers are unselected than deselect
    // modifier group
    const allModifierSelected: boolean[] = []
    let someModifierUnSelected = false
    selectedModifierGroup?.modifiers?.forEach(m => {
      const modifierFound = checkedModifiers?.find(
        ch => ch.modifierID === m.modifierID,
      )
      if (modifierFound) {
        allModifierSelected.push(true)
      } else {
        allModifierSelected.push(false)
        someModifierUnSelected = true
      }
    })

    if (
      allModifierSelected?.length > 0 &&
      allModifierSelected?.every(item => item)
    ) {
      setCheckedModifierGroups(prev => {
        // Check if selected modifier group
        // already in check modifier group
        if (
          prev?.find(
            chMod =>
              chMod.modifierGroupID === selectedModifierGroup.modifierGroupID,
          )
        ) {
          return [...prev]
        }
        return [...prev, selectedModifierGroup]
      })
    }

    if (someModifierUnSelected) {
      setCheckedModifierGroups(prev => [
        ...prev.filter(
          mg => mg.modifierGroupID !== selectedModifierGroup.modifierGroupID,
        ),
      ])
    }
  }, [checkedModifiers, selectedModifierGroup])

  const handleDeleteModifierCheckbox = () => {
    setShowDeleteCheckedModifiersConfirm(true)
  }

  const handleCancelDeleteCheckedModifer = () => {
    setShowDeleteCheckedModifiersConfirm(false)
  }

  // handleConfirmDeleteChecked depedencies
  const bulkDeleteModifiers = async () => {
    const mapModifiers = (mods: Modifier[]) =>
      mods.map((newModifier: Modifier, indx: number) => ({
        ...newModifier,
        sortOrder: mods?.length - indx,
        // Bcs in action we multiply price in min
        // so here we should divide it
        priceInMin: minorUnitToCurrency(newModifier.priceInMin, currencyValue),
      }))

    // Group modifier with it's modifier set (group)
    const collectedModifierGroups: ModifierGroup[] = []

    // Find modifier group that related to checkedModifiers
    // and if found strip checkedModifier from modifier
    // group modifiers
    checkedModifiers?.forEach(cm => {
      filteredModifierGroups?.forEach(mg => {
        if (mg.modifiers?.map(m => m.modifierID).includes(cm.modifierID)) {
          const index = collectedModifierGroups.findIndex(
            c => c.modifierGroupID === mg.modifierGroupID,
          )
          if (index === -1) {
            collectedModifierGroups.push({
              ...mg,
              modifiers: mg.modifiers.filter(
                mgMod => mgMod.modifierID !== cm.modifierID,
              ),
            })
          } else {
            collectedModifierGroups[index].modifiers = collectedModifierGroups[
              index
            ]?.modifiers.filter(col => col?.modifierID !== cm?.modifierID)
          }
        }
      })
    })
    collectedModifierGroups?.forEach((col: ModifierGroup, idx: number) => {
      collectedModifierGroups[idx].modifiers = mapModifiers(
        collectedModifierGroups[idx].modifiers,
      )
    })

    // Delete collected modifier group
    const isEditSuccess = []
    for (let j = 0; j < collectedModifierGroups?.length; j += 1) {
      const editResp: any = await dispatch(
        actionCreator.modifierGroup.editModifierGroup(
          collectedModifierGroups[j],
          currencyValue,
          merchantID,
          merchantGroupID,
          menuGroupID,
        ),
      )
      if (editResp?.type?.endsWith("_SUCCESS")) {
        isEditSuccess.push(true)
      } else if (editResp?.type?.endsWith("_FAIL")) {
        isEditSuccess.push(false)
        const target = editResp?.error?.response?.data?.target
        const message = editResp?.error?.response?.data?.message
        if (target === errorTarget.exceedChangeLimit) {
          const [range, limit, date] = message?.split(":")
          const disabledEditModifierGroup = {
            date,
            limit,
            range,
            modifierGroupID: collectedModifierGroups[j].modifierGroupID,
          } as DisabledEditModifierGroup
          storageHelper.setModifierGroupDisableEdit(disabledEditModifierGroup)
          notification.error({
            message:
              textMap[
                `reachEditLimitTitle${capitalizeFirstLetter(
                  disabledModifierGroup(
                    collectedModifierGroups[j].modifierGroupID,
                  )?.range,
                )}`
              ],
            description: (
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    alertReachEditLimitBody(
                      collectedModifierGroups[j].modifierGroupID,
                    ),
                  ),
                }}
              />
            ),
          })
        } else {
          notification.error({
            message: JSON.stringify(editResp?.error?.response?.data),
          })
        }
      }
      await dispatch(
        actionCreator.modifierGroup.proofModifierGroup(
          collectedModifierGroups?.[j].modifierGroupID,
          merchantID,
          merchantGroupID,
          menuGroupID,
          false,
        ),
      )
      await sleep(1000)
    }
    await refreshMenu()
    setLocalAction(localActionConstants.afterBulkDeleteModifier)
    setCheckedModifierGroups([])
    setCheckedModifiers([])
    setFirstLoad(true)
    dispatch(actionCreator.global.hideLoading())
    if (isEditSuccess.some(el => el) || collectedModifierGroups.length <= 0) {
      notification.success({
        message: textMap.bulkDeleteModifierSuccess.replace(
          /<x>/i,
          `${countCheckedModifiers}`,
        ),
      })
    }

    setCountCheckedModifiers(0)
  }

  // useEffect for bulkDeleteModifiers, this
  // needed for re-select modifiers
  useEffect(() => {
    if (localAction === localActionConstants.afterBulkDeleteModifier) {
      const newSelectedModifierGroup = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === selectedModifierGroup.modifierGroupID,
      )
      if (newSelectedModifierGroup) {
        setSelectedModifierGroup(newSelectedModifierGroup)
        setModifiers(newSelectedModifierGroup.modifiers)
      } else {
        setModifiers([])
      }
      setLocalAction("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredModifierGroups, localAction])

  const handleConfirmDeleteChecked = async () => {
    dispatch(actionCreator.global.showLoading())
    setShowDeleteCheckedModifiersConfirm(false)
    setCountCheckedModifiers(checkedModifiers?.length)
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.clickDeleteItem,
      labels: {
        ...trackingLabels,
        NUM_MODIFIER_SELECTED: checkedModifiers?.length,
        NUM_MODIFIERGROUP_SELECTED: checkedModifierGroups?.length,
        PAGELAYOUT: BOTTOMNAV,
        MODIFIER_ID: JSON.stringify(checkedModifiers?.map(m => m?.modifierID)),
      },
    })
    // Delete checked modifier group
    for (let i = 0; i < checkedModifierGroups?.length; i += 1) {
      const currentModifierGroup: ModifierGroup = checkedModifierGroups?.[i]
      await dispatch(
        actionCreator.modifierGroup.deleteModifierGroup(
          currentModifierGroup?.modifierGroupID,
          merchantID,
          merchantGroupID,
          menuGroupID,
        ),
      )
      await sleep(1000)
      // Remove modifiers under deleted modifier group
      setCheckedModifiers(prev => [
        ...prev?.filter(
          cm =>
            !currentModifierGroup?.modifiers
              ?.map(mod => mod.modifierID)
              ?.includes(cm.modifierID),
        ),
      ])
    }
    setLocalAction(localActionConstants.afterBulkDelete)
  }

  // useEffect after handleConfirmDeleteChecked
  // (bulk delete modifer group/modifier), this needed
  // for trigger bulkDeleteModifier
  useEffect(() => {
    if (localAction === localActionConstants.afterBulkDelete) {
      bulkDeleteModifiers()
      setLocalAction("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filteredModifierGroups,
    localAction,
    selectedModifierGroup,
    modifierGroupForDrawer,
    checkedModifierGroups,
  ])

  const handleOnClickChangeModifierAvailability = () => {
    setShowChangeModifierAvailabilityConfirm(true)
  }

  const handleOnChangeSelectedModifierAvailability = (e: any) => {
    const val = get(e, "target.value", 1)
    setModifierSelectedAvailability(val)
  }

  const handleOnCancelChangeSelectedModifierAvailability = () => {
    setShowChangeModifierAvailabilityConfirm(false)
  }

  const handleOnConfirmChangeSelectedModifierAvailability = async () => {
    setShowChangeModifierAvailabilityConfirm(false)
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.clickChangeAvailability,
      labels: {
        ...trackingLabels,
        NUM_MODIFIER_SELECTED: checkedModifiers?.length,
        NUM_MODIFIERGROUP_SELECTED: checkedModifierGroups?.length,
        PAGELAYOUT: BOTTOMNAV,
        MODIFIER_ID: JSON.stringify(checkedModifiers?.map(m => m?.modifierID)),
      },
    })
    dispatch(actionCreator.global.showLoading())
    const resp: any = await dispatch(
      actionCreator.modifierGroup.changeModifierAvailability(
        modifierSelectedAvailability,
        checkedModifiers.map(cm => cm.modifierID),
        merchantID,
      ),
    )
    let labels: any = {
      ...trackingLabels,
      ENTRY_POINT: "MENU_MODIFIERGROUP_BOTTOMNAV",
      MODIFIER_ID: checkedModifiers.map(m => m?.modifierID),
      NO_MODIFIER_SELECTED: checkedModifiers?.length,
      MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
      VALUE: availabilityStatusTxt(modifierSelectedAvailability)
        .toUpperCase()
        .replace(/ /g, "_"),
    }
    if (resp?.type?.endsWith("_SUCCESS")) {
      await refreshMenu()
      const notifSentence =
        checkedModifiers?.length > 1
          ? textMap[
              `availability${modifierSelectedAvailability}plural`
            ].replace(/<x>/i, `${checkedModifiers?.length}`)
          : textMap[`availability${modifierSelectedAvailability}singular`]
      notification.success({
        message: notifSentence,
      })
      labels = {
        ...labels,
        STATUS: "SUCCESS",
        REASON: "",
        ERROR_MSG: "",
      }
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
    }
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.submitModifierAvailability,
      labels,
    })
    setLocalAction(localActionConstants.afterBulkChangeAvailability)
    setModifierSelectedAvailability(availabilityStatus.available)
    dispatch(actionCreator.global.hideLoading())
  }

  // useEffect for handleOnConfirmChangeSelectedModifierAvailability
  useEffect(() => {
    if (localAction === localActionConstants.afterBulkChangeAvailability) {
      const newSelectedModifierGroup = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === selectedModifierGroup.modifierGroupID,
      )
      if (newSelectedModifierGroup) {
        setSelectedModifierGroup(newSelectedModifierGroup)
        setModifiers(newSelectedModifierGroup.modifiers)
      } else {
        setModifiers([])
      }
      setLocalAction("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredModifierGroups, localAction])

  const handleOnSortEndModifiersOrder = async (
    newOrderedModifiers: Modifier[],
    showLoading: boolean = true,
  ) => {
    if (showLoading) dispatch(actionCreator.global.showLoading())

    let labels: any = {
      ...trackingLabels,
      MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
    }
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifiergroupsRearrangeModifier,
      action: EventAction.submitRearrangeModifier,
      labels,
    })

    // Create deep copies of modifiers to avoid read-only property errors
    // when enablePartialMenu is true (RTK Query returns frozen objects)
    const tmpModifiers = newOrderedModifiers.map(modifier => ({ ...modifier }))
    const modifierLen = tmpModifiers?.length
    for (let i = 0; i < modifierLen; i += 1) {
      // Set sort order
      tmpModifiers[i].sortOrder = modifierLen - i

      // bcs in redux action we multiply priceInMin
      // so here we devide it
      tmpModifiers[i].priceInMin = minorUnitToCurrency(
        tmpModifiers[i].priceInMin,
        currencyValue,
      )
    }

    const tmpModifierGroup = {
      ...selectedModifierGroup,
    }
    tmpModifierGroup.modifiers = tmpModifiers

    const resp: any = await dispatch(
      actionCreator.modifierGroup.editModifierGroup(
        tmpModifierGroup,
        currencyValue,
        merchantID,
        merchantGroupID,
        menuGroupID,
      ),
    )

    if (resp?.type?.endsWith("_SUCCESS")) {
      const proofresp: any = await dispatch(
        actionCreator.modifierGroup.proofModifierGroup(
          tmpModifierGroup.modifierGroupID,
          merchantID,
          merchantGroupID,
          menuGroupID,
        ),
      )
      if (proofresp?.type?.endsWith("_SUCCESS")) {
        labels = {
          ...labels,
          STATUS: "SUCCESS",
          REASON: "",
          ERROR_MSG: "",
        }
        notification.success({
          message: textMap.modifierSorted,
        })
      } else if (proofresp?.type?.endsWith("_FAIL")) {
        labels = {
          ...labels,
          STATUS: "FAILURE",
          ...getResponseErrorEventLabels(proofresp),
        }
        notification.error({
          message: JSON.stringify(proofresp?.error?.response?.data),
        })
      }
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
      const target = resp?.error?.response?.data?.target
      const message = resp?.error?.response?.data?.message
      if (target === errorTarget.exceedChangeLimit) {
        const [range, limit, date] = message?.split(":")
        const disabledEditModifierGroup = {
          date,
          limit,
          range,
          modifierGroupID: tmpModifierGroup.modifierGroupID,
        } as DisabledEditModifierGroup
        storageHelper.setModifierGroupDisableEdit(disabledEditModifierGroup)
        notification.error({
          message:
            textMap[
              `reachEditLimitTitle${capitalizeFirstLetter(
                disabledModifierGroup(tmpModifierGroup.modifierGroupID)?.range,
              )}`
            ],
          description: (
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  alertReachEditLimitBody(tmpModifierGroup.modifierGroupID),
                ),
              }}
            />
          ),
        })
      } else {
        notification.error({
          message: JSON.stringify(resp?.error?.response?.data),
        })
      }
    }

    await refreshMenu()
    setLocalAction(localActionConstants.afterSortOrderModifiers)

    dispatch(actionCreator.global.hideLoading())
    setShowSortOrderModifiersDrawer(false)
  }

  // To prevent exceeding the edit limit for a modifier group
  const debouncedSortHandler = debounceSortHandler(
    handleOnSortEndModifiersOrder,
  )

  // useEffect for handleOnSortEndModifiersOrder
  useEffect(() => {
    if (localAction === localActionConstants.afterSortOrderModifiers) {
      const newSelectedModifierGroup = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === selectedModifierGroup.modifierGroupID,
      )
      if (newSelectedModifierGroup) {
        setSelectedModifierGroup(newSelectedModifierGroup)
        setModifiers(newSelectedModifierGroup.modifiers)
      }
      setLocalAction("")
    }
  }, [
    filteredModifierGroups,
    localAction,
    selectedModifierGroup,
    modifierGroupForDrawer,
  ])

  const handleOnToggleShowSortOrderModifier = (val: boolean) => {
    setShowSortOrderModifiersDrawer(val)

    if (val) {
      TroyWebTracker.sendEvent({
        category: EventCategory.menuModifierGroupsTab,
        action: EventAction.clickModifierMore,
        labels: {
          ...trackingLabels,
          VALUE: REARRANGE,
          MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
          NUM_MODIFIER: modifiers?.length,
        },
      })
    }
  }

  const handleClearModifyModifierGroupErrMsg = () => {
    setModifyModifierGroupErrorMsg(undefined)
  }

  const handleModifyModifierGroupFail = (
    resp: any,
    modifierGroup: ModifierGroup,
  ) => {
    let message = ""
    let target = ""

    if (!isUndefined((resp as any)?.error?.request?.response?.message)) {
      message = (resp as any)?.error?.request?.response?.message
      target = (resp as any)?.error?.request?.response?.target
    } else {
      message = (resp as any)?.error?.response?.data?.message
      target = (resp as any)?.error?.response?.data?.target
    }

    const errMsg = { key: "", message: "" }
    let errModifier
    if (target === errorTarget.exceedModifierGroupNameLengthLimit) {
      errMsg.key = "modifierGroupName"
      errMsg.message = textMap.itemNameExceedLimit.replace(/\$x/i, message)
    } else if (target === errorTarget.exceedModifierNameLengthLimit) {
      errModifier = modifierGroup?.modifiers?.find(
        m => m?.modifierName?.length > Number(message),
      )
      errMsg.key = `modifierName[${errModifier?.modifierID}]`
      errMsg.message = textMap.itemNameExceedLimit.replace(/\$x/i, message)
    } else if (target === errorTarget.exceedConstraint) {
      errModifier = modifierGroup?.modifiers.find(m => {
        const lastSelectedModifier = selectedModifierGroup?.modifiers?.find(
          lm => lm?.modifierID === m?.modifierID,
        )
        const newPrice = Number(m?.priceInMin)
        const oldPrice = minorUnitToCurrency(
          lastSelectedModifier?.priceInMin,
          currencyValue,
        )
        return (
          Math.abs(oldPrice - newPrice) / oldPrice >
          minorUnitToCurrency(Number(message), currencyValue)
        )
      })
      errMsg.key = `additionalPrice[${errModifier?.modifierID}]`
      errMsg.message = textMap.priceExceedLimit.replace(/\$count/i, message)
    } else if (target === errorTarget.exceedChangeLimit) {
      const [range, limit, date] = message?.split(":")
      const disabledEditModifierGroup = {
        date,
        limit,
        range,
        modifierGroupID: modifierGroup.modifierGroupID,
      } as DisabledEditModifierGroup
      storageHelper.setModifierGroupDisableEdit(disabledEditModifierGroup)
      errMsg.key = errorTarget.exceedChangeLimit
    } else if (target === errorTarget.modifierGroupArchived) {
      notification.error({
        message: textMap.modifierGropNotExist,
      })
      return
    } else if (target === errorTarget.exceedMaxDeviation) {
      errMsg.message = textMap.errorPriceDeviation.replace(/<limit>/i, message)
    } else {
      errMsg.message = JSON.stringify(
        (resp as any)?.error?.request?.response ?? "ERROR",
      )
    }
    setModifyModifierGroupErrorMsg(errMsg)
  }

  const handleCreateNewModifierGroup: ModifierGroupsDrawerProps["onCreateNewModifierGroup"] = async ({
    advancedPricingMap,
    bcrsMap,
  }) => {
    dispatch(actionCreator.global.showLoading())
    handleClearModifyModifierGroupErrMsg()

    const newModifierGroup: ModifierGroup = {
      ...modifierGroupForDrawer,
      nameTranslation: generateTranslationParam({
        menuTranslationSetting,
        translationSetting: modifierGroupForDrawer.nameTranslation,
        originalTranslationFromDSMap,
        entity: "modifierGroup",
        textType: "name",
        text: modifierGroupForDrawer.modifierGroupName,
        destinationKey: modifierGroupForDrawer.modifierGroupID,
      }),
    }
    newModifierGroup.modifiers = [...modifiersForDrawer].map(mod => ({
      ...mod,
      advancedPricing: advancedPricingMap[mod.modifierID],
      bcrsInfo: mergeBCRSInfo(mod.bcrsInfo, bcrsMap[mod.modifierID]),
      nameTranslation: generateTranslationParam({
        menuTranslationSetting,
        translationSetting: mod.nameTranslation,
        originalTranslationFromDSMap,
        entity: "modifier",
        textType: "name",
        text: mod.modifierName,
        destinationKey: `${modifierGroupForDrawer.modifierGroupID},${mod.modifierID}`,
      }),
    }))
    const resp: any = await dispatch(
      actionCreator.modifierGroup.createModifierGroup(
        newModifierGroup,
        currencyValue,
        merchantID,
        merchantGroupID,
        menuGroupID,
      ),
    )

    let labels: any = {
      ...(merchantID
        ? { STORE_ID: merchantID }
        : { MERCHANT_GROUP_ID: merchantGroupID, MENU_GROUP_ID: menuGroupID }),
      MODIFIER_GROUP_ID: "",
      INTENT: "ADD_MODIFIERGROUP",
    }
    if (resp?.type?.endsWith("_SUCCESS")) {
      labels = {
        ...labels,
        STATUS: "SUCCESS",
        REASON: "",
        ERROR_MSG: "",
      }
      const modifierGroupID = resp?.payload?.data?.modifierGroupID
      const proofResp: any = await dispatch(
        actionCreator.modifierGroup.proofModifierGroup(
          modifierGroupID,
          merchantID,
          merchantGroupID,
          menuGroupID,
        ),
      )
      const respMenu = ((await refreshMenu()) as AnyAction) as AxiosAction<
        FetchMenuResponse
      >

      // Select the newly created modifier group. need the new data after page refresh
      const newModifierGroups = respMenu?.payload?.data?.modifierGroups ?? []
      if (newModifierGroups.length) {
        handleSelectModifierGroup(
          // Note: seems like the newly created "modifierGroupID" is changed after "proofModifierGroup"
          // this small hack assumes that the newly created modifierGroup is the first element
          newModifierGroups[0],
        )
      }

      setLocalAction(localActionConstants.afterCreateNewModifierGroup)
      dispatch(actionCreator.global.hideLoading())
      if (proofResp?.type?.endsWith("_SUCCESS")) {
        notification.success({
          message: textMap.notifMgCreated,
        })
      }
      handleOnCloseDrawer()
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
      handleModifyModifierGroupFail(resp, newModifierGroup)
    }
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifiergroupsModifymodifiergroup,
      action: EventAction.submitModifyModifiergroup,
      labels,
    })
    dispatch(actionCreator.global.hideLoading())
  }

  // handleCreateNewModifierGroup dependencies
  const linkItemToModifier = async (modifierGroupID: string) => {
    for (let i = 0; i < linkedItems.length; i += 1) {
      const itemID = linkedItems[i].itemID ?? ""
      if (!isRtkFlagLoading && isRtkLinkItemToModifierGroupEnabled) {
        const result = await linkItemToModifierGroupRtk({
          merchantID,
          merchantGroupID,
          modifierGroupID,
          itemID,
          menuGroupID,
          showError: false,
        })
        if (result.error) {
          const errData = (result.error as any)?.data
          const target = errData?.target
          const message = errData?.message
          if (target === errorTarget.exceedMaxModifierGroupPerItemLimit) {
            notification.error({
              message: textMap.linkItemLimit.replace(/\$count/i, message),
            })
          } else if (!isEmpty(message)) {
            notification.error({
              message,
            })
          } else {
            notification.error({
              message: textMap.generalError,
            })
          }
        }
        TroyWebTracker.sendEvent({
          category: EventCategoryEng.rtkMigration,
          action: EventActionEng.linkItemToModifierGroup,
          labels: {
            MERCHANT_ID: merchantID,
            IS_RTK_ENABLED: isRtkLinkItemToModifierGroupEnabled,
            FROM_RTK_QUERY: true,
            FROM_OLD_REDUX: false,
            ACTION_NAME: "linkItemToModifierGroup",
          },
        })
      } else if (!isRtkFlagLoading) {
        const linkResp: any = await dispatch(
          actionCreator.modifierGroup.linkItemToModifierGroup(
            modifierGroupID,
            itemID,
            merchantID,
            merchantGroupID,
            menuGroupID,
          ),
        )
        if (linkResp?.type?.endsWith("_FAIL")) {
          const target = linkResp?.error?.response?.data?.target
          const message = linkResp?.error?.response?.data?.message
          if (target === errorTarget.exceedMaxModifierGroupPerItemLimit) {
            // special condition when modifier reach limit
            notification.error({
              message: textMap.linkItemLimit.replace(/\$count/i, message),
            })
          } else {
            // check for another error
            const errStatus = linkResp?.error?.request?.status

            if (errStatus >= 400 && errStatus < 500 && !isEmpty(message)) {
              notification.error({
                message,
              })
            } else {
              notification.error({
                message: textMap.generalError,
              })
            }
          }
        }
        TroyWebTracker.sendEvent({
          category: EventCategoryEng.rtkMigration,
          action: EventActionEng.linkItemToModifierGroup,
          labels: {
            MERCHANT_ID: merchantID,
            IS_RTK_ENABLED: isRtkLinkItemToModifierGroupEnabled,
            FROM_RTK_QUERY: false,
            FROM_OLD_REDUX: true,
            ACTION_NAME: "linkItemToModifierGroup",
          },
        })
      }
    }
    await refreshMenu()
    setFirstLoad(true)
  }

  // useEffect for handleCreateNewModifierGroup
  useEffect(() => {
    if (localAction === localActionConstants.afterCreateNewModifierGroup) {
      if (!isEmpty(filteredModifierGroups?.[0]) && linkedItems.length) {
        linkItemToModifier(filteredModifierGroups?.[0]?.modifierGroupID)
      }
      setLocalAction("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredModifierGroups, localAction])

  const handleTogglePreviewModifierGroup = (show: boolean) => {
    if (show) {
      const itemForPreview = linkedItems?.[0]
      if (itemForPreview) {
        setPreviewModifierGroup({
          ...modifierGroupForDrawer,
          modifiers: [...modifiersForDrawer],
        })
        setPreviewItem(itemForPreview)
        setShowPreviewModifierGroupDrawer(show)
      }
    } else {
      setShowPreviewModifierGroupDrawer(show)
    }
  }

  // Debounced search function
  const handleSearchItem = useMemo(
    () =>
      debounce((e: any) => {
        const key = e.target.value || ""

        if (enablePartialMenu) {
          // Use API search for partial menu
          if (key.trim().length > 0) {
            setSearchValue(key.trim())
            triggerSearch({
              merchantID,
              merchantGroupID,
              searchKey: key.trim(),
            })
          } else {
            setSearchValue("")
            setItems(menuV3ItemsList)
          }
        } else if (key.length > 0) {
          // Legacy client-side filtering
          setItems([
            ...allItems.filter((item: Item) =>
              item.itemName?.toLowerCase()?.includes(key.toLowerCase()),
            ),
          ])
        } else {
          setItems(allItems)
        }
      }, DEFAULT_DEBOUNCE_WAIT_TIME),
    [
      enablePartialMenu,
      triggerSearch,
      merchantID,
      merchantGroupID,
      menuV3ItemsList,
      allItems,
    ],
  )

  const handleSubmitEditModifierGroup: ModifierGroupsDrawerProps["onSubmitEditModifierGroup"] = async ({
    advancedPricingMap,
    bcrsMap,
  }) => {
    dispatch(actionCreator.global.showLoading())
    handleClearModifyModifierGroupErrMsg()

    const tmpEditedModifierGroup: ModifierGroup = {
      ...modifierGroupForDrawer,
      nameTranslation: generateTranslationParam({
        menuTranslationSetting,
        translationSetting: modifierGroupForDrawer.nameTranslation,
        originalTranslationFromDSMap,
        entity: "modifierGroup",
        textType: "name",
        text: modifierGroupForDrawer.modifierGroupName,
        destinationKey: modifierGroupForDrawer.modifierGroupID,
      }),
    }

    const tmpEditedModifierGroupForError = {
      ...modifierGroupForDrawer,
    }

    const tmpModifiers: Modifier[] = [...modifiersForDrawer].map(mod => ({
      ...mod,
      advancedPricing: advancedPricingMap[mod.modifierID],
      bcrsInfo: mergeBCRSInfo(mod.bcrsInfo, bcrsMap[mod.modifierID]),
      nameTranslation: generateTranslationParam({
        menuTranslationSetting,
        translationSetting: mod.nameTranslation,
        originalTranslationFromDSMap,
        entity: "modifier",
        textType: "name",
        text: mod.modifierName,
        destinationKey: `${modifierGroupForDrawer.modifierGroupID},${mod.modifierID}`,
      }),
    }))
    const modifierLen = tmpModifiers?.length
    for (let i = 0; i < modifierLen; i += 1) {
      // Set modifier id to empty if the id is generated
      const modifierIDExist = selectedModifierGroup?.modifiers?.find(
        mod => mod.modifierID === tmpModifiers[i].modifierID,
      )
      if (!modifierIDExist) {
        tmpModifiers[i].modifierID = ""
      }

      // Set sort order
      tmpModifiers[i].sortOrder = modifierLen - i
    }
    tmpEditedModifierGroup.modifiers = tmpModifiers
    tmpEditedModifierGroupForError.modifiers = modifiersForDrawer

    const resp: any = await dispatch(
      actionCreator.modifierGroup.editModifierGroup(
        tmpEditedModifierGroup,
        currencyValue,
        merchantID,
        merchantGroupID,
        menuGroupID,
      ),
    )

    let labels: any = {
      ...trackingLabels,
      MODIFIER_GROUP_ID: tmpEditedModifierGroup?.modifierGroupID,
      INTENT: "EDIT_MODIFIERGROUP",
    }

    if (resp?.type?.endsWith("_SUCCESS")) {
      labels = {
        ...labels,
        STATUS: "SUCCESS",
        REASON: "",
        ERROR_MSG: "",
      }
      await dispatch(
        actionCreator.modifierGroup.proofModifierGroup(
          modifierGroupForDrawer.modifierGroupID,
          merchantID,
          merchantGroupID,
          menuGroupID,
        ),
      )

      let successResponse = true
      const unchangedItems = linkedItems
        .filter(item =>
          selectedModifierGroup?.relatedItemIDs.includes(item.itemID!),
        )
        .map(item => item.itemID)
      const removedLinkItems = selectedModifierGroup.relatedItemIDs.filter(
        item => !unchangedItems.includes(item),
      )
      const addedLinkItems = linkedItems
        .filter(item => !unchangedItems.includes(item.itemID))
        .map(item => item.itemID)

      // Unlink item
      await Promise.all(
        removedLinkItems.map(async item => {
          await dispatch(
            actionCreator.modifierGroup.UnLinkItemFromModifierGroup(
              modifierGroupForDrawer.modifierGroupID,
              item,
              merchantID,
              merchantGroupID,
              menuGroupID,
            ),
          )
        }),
      )

      // Link new item
      await Promise.all(
        addedLinkItems.map(async item => {
          if (!isRtkFlagLoading && isRtkLinkItemToModifierGroupEnabled) {
            const result = await linkItemToModifierGroupRtk({
              merchantID,
              merchantGroupID,
              modifierGroupID: modifierGroupForDrawer.modifierGroupID,
              itemID: item ?? "",
              menuGroupID,
              showError: false,
            })
            if (result.error) {
              successResponse = false
              const errData = (result.error as any)?.data
              const target = errData?.target
              const message = errData?.message
              if (target === errorTarget.exceedMaxModifierGroupPerItemLimit) {
                notification.error({
                  message: textMap.linkItemLimit.replace(/\$count/i, message),
                })
              } else if (target === errorTarget.itemPromo) {
                notification.error({
                  message: textMap.itemPromo,
                })
              } else if (!isEmpty(message)) {
                notification.error({
                  message,
                })
              } else {
                notification.error({
                  message: textMap.generalError,
                })
              }
            }
            TroyWebTracker.sendEvent({
              category: EventCategoryEng.rtkMigration,
              action: EventActionEng.linkItemToModifierGroup,
              labels: {
                MERCHANT_ID: merchantID,
                IS_RTK_ENABLED: isRtkLinkItemToModifierGroupEnabled,
                FROM_RTK_QUERY: true,
                FROM_OLD_REDUX: false,
                ACTION_NAME: "linkItemToModifierGroup",
              },
            })
          } else if (!isRtkFlagLoading) {
            const linkItemResp = await dispatch(
              actionCreator.modifierGroup.linkItemToModifierGroup(
                modifierGroupForDrawer.modifierGroupID,
                item ?? "",
                merchantID,
                merchantGroupID,
                menuGroupID,
              ),
            )
            let errResp = (linkItemResp as any)?.error?.request?.response

            if (!isEmpty(errResp)) {
              successResponse = false

              if (typeof errResp === "string") {
                try {
                  errResp = JSON.parse(errResp)
                } catch (error) {
                  errResp = { target: "", message: "" }
                }
              }

              const target = errResp?.target
              const message = errResp?.message

              if (target === errorTarget.exceedMaxModifierGroupPerItemLimit) {
                // special condition when modifier reach limit
                notification.error({
                  message: textMap.linkItemLimit.replace(/\$count/i, message),
                })
              } else if (target === errorTarget.itemPromo) {
                notification.error({
                  message: textMap.itemPromo,
                })
              } else {
                // check for another error
                const errStatus = (linkItemResp as any)?.error?.request?.status

                if (errStatus >= 400 && errStatus < 500 && !isEmpty(message)) {
                  notification.error({
                    message,
                  })
                } else {
                  notification.error({
                    message: textMap.generalError,
                  })
                }
              }
            }
            TroyWebTracker.sendEvent({
              category: EventCategoryEng.rtkMigration,
              action: EventActionEng.linkItemToModifierGroup,
              labels: {
                MERCHANT_ID: merchantID,
                IS_RTK_ENABLED: isRtkLinkItemToModifierGroupEnabled,
                FROM_RTK_QUERY: false,
                FROM_OLD_REDUX: true,
                ACTION_NAME: "linkItemToModifierGroup",
              },
            })
          }
        }),
      )

      await refreshMenu()
      setLocalAction(localActionConstants.afterEditModifierGroup)
      dispatch(actionCreator.global.hideLoading())
      if (successResponse) {
        notification.success({
          message: textMap.notifMgUpdated,
        })
        handleOnCloseDrawer()
      }
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
      handleModifyModifierGroupFail(resp, tmpEditedModifierGroupForError)
    }
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifiergroupsModifymodifiergroup,
      action: EventAction.submitModifyModifiergroup,
      labels,
    })
    dispatch(actionCreator.global.hideLoading())
  }

  // useEffect after handleSubmitEditModifierGroup
  useEffect(() => {
    if (localAction === localActionConstants.afterEditModifierGroup) {
      const newSelectedModifierGroup = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === modifierGroupForDrawer.modifierGroupID,
      )
      if (newSelectedModifierGroup) {
        setSelectedModifierGroup(newSelectedModifierGroup)
        setModifiers(newSelectedModifierGroup.modifiers)

        // When on selection mode, need to update
        // checkedModifierGroups to reflect
        // relatedItemIDs changes
        const newCheckedModifierGroups = filteredModifierGroups?.filter(mg =>
          checkedModifierGroups
            ?.map((ch: ModifierGroup) => ch.modifierGroupID)
            .includes(mg.modifierGroupID),
        )
        setCheckedModifierGroups(newCheckedModifierGroups)
      }
      setLocalAction("")
    }
  }, [
    filteredModifierGroups,
    localAction,
    selectedModifierGroup,
    modifierGroupForDrawer,
    checkedModifierGroups,
  ])

  const handleChangeModifierAvailability = async (
    modifierID: string,
    availAbilityStatus: number,
  ) => {
    dispatch(actionCreator.global.showLoading())
    const resp: any = await dispatch(
      actionCreator.modifierGroup.changeModifierAvailability(
        availAbilityStatus,
        [modifierID],
        merchantID,
      ),
    )

    let labels: any = {
      ...trackingLabels,
      ENTRY_POINT: "AVAILABILITY_DROPDOWN",
      MODIFIER_ID: [modifierID],
      NO_MODIFIER_SELECTED: 1,
      MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
      VALUE: availabilityStatusTxt(availAbilityStatus)
        .toUpperCase()
        .replace(/ /g, "_"),
    }
    if (resp?.type?.endsWith("_SUCCESS")) {
      await refreshMenu()
      notification.success({
        message: textMap[`availability${availAbilityStatus}singular`],
      })
      labels = {
        ...labels,
        STATUS: "SUCCESS",
        REASON: "",
        ERROR_MSG: "",
      }
    } else if (resp?.type?.endsWith("_FAIL")) {
      labels = {
        ...labels,
        STATUS: "FAILURE",
        ...getResponseErrorEventLabels(resp),
      }
    }
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifierGroupsTab,
      action: EventAction.submitModifierAvailability,
      labels,
    })
    setLocalAction(localActionConstants.afterChangeAvailability)
    dispatch(actionCreator.global.hideLoading())
  }

  // useEffect for handleChangeModifierAvailability
  useEffect(() => {
    if (localAction === localActionConstants.afterChangeAvailability) {
      const newSelectedModifierGroup = filteredModifierGroups?.find(
        mg => mg.modifierGroupID === selectedModifierGroup.modifierGroupID,
      )
      if (newSelectedModifierGroup) {
        setSelectedModifierGroup(newSelectedModifierGroup)
        setModifiers(newSelectedModifierGroup.modifiers)
      } else {
        setModifiers([])
      }
      setLocalAction("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredModifierGroups, localAction])

  // MenuTranslation useEffect for modifier drawer reset value updated
  useEffect(() => {
    if (isMenuTranslation && modifierGroupSelected) {
      if (
        modifierGroupSelected !== modifierGroupForDrawer &&
        (modifierGroupSelected.nameTranslation?.originalText ===
          modifierGroupForDrawer.modifierGroupName ||
          modifierGroupSelected.resetNameTranslation?.originalText ===
            modifierGroupForDrawer.modifierGroupName ||
          modifierGroupSelected.translationError !==
            modifierGroupForDrawer.translationError)
      ) {
        const updatedValue = {
          ...modifierGroupForDrawer,
          nameTranslation: modifierGroupSelected.nameTranslation,
          resetNameTranslation: modifierGroupSelected.resetNameTranslation,
          translationError: modifierGroupSelected.translationError,
        }
        setModifierGroupForDrawer(updatedValue)
      }
    }
    if (isMenuTranslation && modifierSelected) {
      if (modifierSelected !== modifiersForDrawer) {
        const updatedModifier = modifiersForDrawer.map(a => {
          const exists = modifierSelected.find(
            b => a.modifierID === b.modifierID,
          )
          if (
            exists &&
            (exists.nameTranslation?.originalText === a.modifierName ||
              exists.resetNameTranslation?.originalText === a.modifierName ||
              exists.translationError !== a.translationError)
          ) {
            return {
              ...a,
              nameTranslation: exists.nameTranslation,
              resetNameTranslation: exists.resetNameTranslation,
              translationError: exists.translationError,
            }
          }
          return a
        })
        setModifiersForDrawer(updatedModifier)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifierGroupSelected, modifierSelected, outletV2])

  const handleUpdateModifierTranslation = (value?: TranslationDetail) => {
    const newValue: ModifierGroup = {
      ...modifierGroupForDrawer,
      nameTranslation: value?.nameTranslation,
      translationError: undefined,
    }
    setModifierGroupForDrawer(newValue)
    dispatch(
      actionCreator.menu.setModifierGroupNameTranslation(
        modifierGroupForDrawer.modifierGroupID,
        value,
      ),
    )
  }

  const handleUpdateModifierOptionTranslation = (value: Modifier[]) => {
    const updatedModifier = modifiersForDrawer.map(a => {
      const exists = value.find(b => a.modifierID === b.modifierID)
      if (exists) {
        return {
          ...a,
          nameTranslation: exists.nameTranslation,
          resetNameTranslation: exists.resetNameTranslation,
          translationError: exists.translationError,
        }
      }
      return a
    })
    setModifiersForDrawer(updatedModifier)
    dispatch(actionCreator.menu.setModifierNameTranslation(updatedModifier))
  }

  const handleCloseModifierTranslation = (position: number) => {
    const updatedModifier = modifiersForDrawer.map(
      (modifier: Modifier, index: number) => {
        if (index === position) {
          return {
            ...modifier,
            resetNameTranslation: undefined,
          }
        }
        return modifier
      },
    )
    setModifiersForDrawer(updatedModifier)
    dispatch(actionCreator.menu.setModifierNameTranslation(updatedModifier))
  }

  const handleOnChangeModifierName = (index: number, modifierName: string) => {
    const newModifiersForDrawer = [...modifiersForDrawer]
    newModifiersForDrawer[index].modifierName = modifierName
    setModifiersForDrawer(newModifiersForDrawer)
  }

  const handleOnChangeModifierAdditionalPrice = (
    index: number,
    additionalPrice: string,
  ) => {
    const newModifiersForDrawer = [...modifiersForDrawer]
    newModifiersForDrawer[index].priceInMin = additionalPrice
      ? Number(additionalPrice)
      : 0
    setModifiersForDrawer(newModifiersForDrawer)
  }

  const handleOnSearchModifierGroup = (keyword: string) => {
    setSelectedModifierGroup(emptyModifierGroup)
    setModifiers([])
    setSearchFilter(keyword)
    if (enablePartialMenu && keyword) {
      triggerSearchMenus(
        { merchantID, merchantGroupID, keyword, entityType: "OPTION" },
        false,
      )
    }
  }

  const handleSortModifierClose = () => {
    setShowSortOrderModifiersDrawer(false)
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifiergroupsRearrangeModifier,
      action: EventAction.clickExit,
      labels: {
        ...trackingLabels,
        MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
      },
    })
  }

  const handleModifierSortchange = () => {
    TroyWebTracker.sendEvent({
      category: EventCategory.menuModifiergroupsRearrangeModifier,
      action: EventAction.rearrangeModifier,
      labels: {
        ...trackingLabels,
        MODIFIER_GROUP_ID: selectedModifierGroup?.modifierGroupID,
      },
    })
  }

  const onGetTranslation = useCallback(
    debounce((target: TranslationParams) => {
      const textTargetLang =
        target.menuTranslationSetting?.translationModelSupportedLanguages
      if (textTargetLang?.length && target.value?.trim().length) {
        const data: MenuTranslationRequestData = {
          textType: "name",
          entity: camelCase(
            target.entity,
          ) as MenuTranslationRequestData["entity"],
          text: target.value,
          textSourceLang:
            target.menuTranslationSetting?.menuDefaultLanguage || "",
          textTargetLang,
          destinationKey: target.destinationKey,
        }
        fetchGetTranslation({
          getTranslationBaseAction: actions.GET_TRANSLATION,
          dispatch,
          data,
          merchantID: target.merchantID,
          merchantGroupID,
          menuGroupID,
          isRtkFlagLoading,
          isRtkGetTranslationEnabled,
          getTranslationRtk,
          dispatchLegacyGetTranslation: () =>
            dispatch(
              actionCreator.menu.getTranslation({
                data,
                merchantID: target.merchantID,
                merchantGroupID,
                menuGroupID,
              }),
            ),
        })
        TroyWebTracker.sendEvent({
          category: EventCategoryEng.translationValueFetch,
          action: EventActionEng.modifierAutoTranslationFetch,
        })
      }
    }, DEFAULT_DEBOUNCE_WAIT_TIME),
    [dispatch, isRtkFlagLoading, isRtkGetTranslationEnabled, getTranslationRtk],
  )

  // Select first modifier group on first load page
  useEffect(() => {
    if (
      !isEmpty(filteredModifierGroups) &&
      firstLoad &&
      isEmpty(modifierParam)
    ) {
      const isSelectedModifierGroupExist = filteredModifierGroups.find(
        modifierGroup =>
          modifierGroup.modifierGroupID ===
          selectedModifierGroup.modifierGroupID,
      )
      if (!isSelectedModifierGroupExist) {
        const modifierGroup = filteredModifierGroups?.[0]
        setModifiers(modifierGroup.modifiers)
        setSelectedModifierGroup(modifierGroup)
        setSelectedRequireType(modifierGroup)
      } else {
        // helper (refresher to get new linkedItems) for linkItemToModifier
        setSelectedModifierGroup(isSelectedModifierGroupExist)
      }

      setFirstLoad(false)
    }
  }, [filteredModifierGroups, firstLoad])

  useEffect(() => {
    if (drawerVisible) {
      dispatch(actionCreator.menu.resetAutoTranslationQueue())
    }
  }, [drawerVisible])

  const hasModifierGroups = filteredModifierGroups?.length > 0

  const { hideCreateAction } = useInventoryContext()

  return (
    <div
      css={css`
        ${modifierGroupContainer}
        ${showCheckbox
          ? css`
              height: calc(100% - 90px);
            `
          : ""}
      `}
    >
      <ModifierGroupsHeader
        hideCreateBtn={hideCreateAction}
        disableCreateBtn={showCheckbox || !isEditAllowed}
        onSearchModifierGroup={handleOnSearchModifierGroup}
        onClickCreateNewModifier={handleOnClickCreateNewModifier}
      />
      {isLoadingModifierGroupsData || hasModifierGroups ? (
        <Row
          css={css`
            height: 100%;
            width: 100%;
          `}
        >
          <Col flex="330px">
            <ModifierGroupList
              data-testid="modifier-group-list"
              modifierGroups={filteredModifierGroups}
              selectedModifierGroup={selectedModifierGroup}
              showCheckbox={showCheckbox}
              checkedModifierGroups={checkedModifierGroups}
              checkedModifiers={checkedModifiers}
              onChangeCheckboxModifierGroup={
                handleOnChangeCheckboxModifierGroup
              }
              onToggleShowCheckboxModifierGroup={(visible: boolean) =>
                handleOnToggleCheckbox(visible, EventSource.MODIFIER_GROUP)
              }
              onClickModifierGroup={handleSelectModifierGroup}
              onClickEditModifier={handleOnClickEditModifier}
              searchString={isModifierGroupSearchActive ? searchFilter : ""}
              isLoading={
                isModifierGroupSearchActive
                  ? isSearchingModifierGroups
                  : enablePartialMenu && isLoadingModifierGroups
              }
              {...(enablePartialMenu && {
                fetchNextPage: isModifierGroupSearchActive
                  ? undefined
                  : fetchNextPageModifierGroups,
                hasNextPage: isModifierGroupSearchActive
                  ? false
                  : hasNextPageModifierGroups,
                isFetchingNextPage: isModifierGroupSearchActive
                  ? false
                  : isFetchingNextPageModifierGroups,
                error: modifierGroupsError,
              })}
            />
          </Col>
          <Col flex="auto">
            <ModifierList
              data-testid="modifier-list"
              modifiers={modifiers}
              showCheckbox={showCheckbox}
              checkedModifiers={checkedModifiers}
              onChangeModifierAvailability={handleChangeModifierAvailability}
              onToggleShowSortOrderModifier={
                handleOnToggleShowSortOrderModifier
              }
              onChangeModifierCheckbox={handleOnChangeModifierCheckbox}
              onClickEditModifier={handleOnClickEditModifier}
              showEditBtn={!isEmpty(selectedModifierGroup?.modifierGroupID)}
              onToggleShowCheckboxModifier={(visible: boolean) =>
                handleOnToggleCheckbox(visible, EventSource.MODIFIER)
              }
              onSort={newList => {
                debouncedSortHandler(newList, false)
              }}
              isLoading={enablePartialMenu && isLoadingModifierGroups}
              searchString={searchFilter}
            />
          </Col>
        </Row>
      ) : (
        <EmptyModifierGroups
          data-testid="empty-modifier-groups"
          onClick={handleOnClickCreateNewModifier}
          disabledMode={!isEditAllowed}
        />
      )}
      <ModifierGroupsDrawerForm
        data-testid="modifier-groups-drawer-form"
        isMartStore={isMartStore}
        menu={menu}
        visible={drawerVisible}
        linkedItemChange={linkedItemChange}
        isEditAllowed={isEditAllowed}
        linkedItems={linkedItems}
        isLoadingLinkedItems={isLoadingLinkedItems}
        hasMoreBatches={hasMoreBatches}
        onLoadMoreBatches={handleLoadMoreBatches}
        linkedItemsError={linkedItemsError}
        requiredType={requiredType}
        textMap={textMap}
        createNewModifierGroupClicked={createNewModifierGroupClicked}
        modifyModifierGroupErrorMsg={modifyModifierGroupErrorMsg}
        onClearModifyModifierGroupErrMsg={handleClearModifyModifierGroupErrMsg}
        onToggleCreateNewModifierGroupClicked={
          handleToggleCreateNewModifierGroupClicked
        }
        onChangeModifierName={handleOnChangeModifierName}
        onChangeModifierAdditionalPrice={handleOnChangeModifierAdditionalPrice}
        onChangeModifierGroupName={handleOnChangeModifierGroupName}
        onSubmitEditModifierGroup={handleSubmitEditModifierGroup}
        onCloseDrawer={handleOnCloseDrawer}
        onClickLinkItem={handleOnClickLinkItem}
        onSortOrderModifierChange={handleOnSortOrderModifierChange}
        onAddEmptyModifier={handleOnAddEmptyModifier}
        onRemoveModifier={handleOnRemoveModifier}
        onChangeModifierGroupRequiredType={
          handleOnChangeModifierGroupRequiredType
        }
        onChangeModifierGroupStartValue={handleOnChangeModifierGroupStartValue}
        onChangeModifierGroupEndValue={handleOnChangeModifierGroupEndValue}
        onChangeModifierGroupSelectionRuleChange={
          handleOnChangeModifierGroupSelectionRuleChange
        }
        onDeleteModifierGroup={handleOnDeleteModifierGroup}
        onCreateNewModifierGroup={handleCreateNewModifierGroup}
        onTogglePreview={handleTogglePreviewModifierGroup}
        modifierGroupForDrawer={modifierGroupForDrawer}
        workingModifiers={modifiersForDrawer}
        title={modifierGroupDrawerTitle}
        btnTitle={modifierGroupDrawerBtnTitle}
        isServiceBasedMenuEnabled={isServiceBasedMenuEnabled}
        onUpdateModifierTranslation={handleUpdateModifierTranslation}
        onUpdateModifierOptionTranslation={
          handleUpdateModifierOptionTranslation
        }
        onGetTranslation={onGetTranslation}
        isMenuTranslation={isMenuTranslation}
        isAutoTranslationEnabled={isAutoTranslationEnabled}
        menuTranslationSetting={menuTranslationSetting}
        onCloseModifierTranslation={handleCloseModifierTranslation}
        autoTranslationQueue={autoTranslationQueue}
      />
      <LinkedItemsDrawer
        visible={linkedItemsDrawerVisble}
        items={items}
        linkedItems={linkedItems}
        modifierGroupID={modifierGroupForDrawer.modifierGroupID}
        onSearchItem={handleSearchItem}
        onCloseDrawer={handleOnCloseLinkedItemsDrawer}
        onItemCheckboxChange={handleItemCheckboxChange}
        onSubmitLinkitem={handleSubmitLinkItem}
        {...(enablePartialMenu && {
          isLoading: isSearching ? isSearchFetching : isLoadingItems,
          hasNextPage: isSearching ? false : hasNextPageItems,
          onLoadMore: isSearching ? undefined : handleLoadMoreItems,
        })}
      />
      {showCheckbox && (
        <SelectionAction
          checkedModifierGroups={checkedModifierGroups}
          checkedModifiers={checkedModifiers}
          showDeleteCheckedModifiersConfirm={showDeleteCheckedModifiersConfirm}
          showChangeModifierAvailabilityConfirm={
            showChangeModifierAvailabilityConfirm
          }
          modifierSelectedAvailability={modifierSelectedAvailability}
          onConfirmChangeSelectedModifierAvailability={
            handleOnConfirmChangeSelectedModifierAvailability
          }
          onCancelChangeSelectedModifierAvailability={
            handleOnCancelChangeSelectedModifierAvailability
          }
          onChangeSelectedModifierAvailability={
            handleOnChangeSelectedModifierAvailability
          }
          onClickChangeModifierAvailability={
            handleOnClickChangeModifierAvailability
          }
          handleCloseCheckbox={handleCloseCheckbox}
          onDeleteModifierCheckbox={handleDeleteModifierCheckbox}
          onCancelDeleteCheckedModifer={handleCancelDeleteCheckedModifer}
          onConfirmDeleteChecked={handleConfirmDeleteChecked}
        />
      )}
      {showSortOrderModifiersDrawer && (
        <SortDrawer
          items={modifiers}
          title={textMap.rearrangeModifier}
          visible={showSortOrderModifiersDrawer}
          onClose={handleSortModifierClose}
          onSave={handleOnSortEndModifiersOrder}
          onSort={handleModifierSortchange}
          renderRowContent={(modifier: Modifier) => (
            <SortOrderModifierRow modifier={modifier} />
          )}
        />
      )}
      <ModifierGroupPreviewDrawer
        showPreviewModifierGroupDrawer={showPreviewModifierGroupDrawer}
        previewModifierGroup={previewModifierGroup}
        previewItem={previewItem}
        onToggleDrawer={handleTogglePreviewModifierGroup}
      />
    </div>
  )
}
